
import { configureStore } from "@reduxjs/toolkit";
import ResumeReducer from "../reducers/resumeSlice";
import { useState } from "react";

export const store = configureStore({

    reducer: {
        adminInfooo: ResumeReducer
    }

});